export default __webpack_public_path__ + "static/media/kitchen3-after2-1440w.fa218577.avif";